import { createContext, useContext, useState, type ReactNode } from "react";

interface PlayNoticeContextValue {
  showNotice: (title?: string) => void;
}

const PlayNoticeContext = createContext<PlayNoticeContextValue>({
  showNotice: () => {},
});

export function usePlayNotice(): PlayNoticeContextValue {
  return useContext(PlayNoticeContext);
}

export default function PlayNoticeProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");

  const showNotice = (name?: string) => {
    setTitle(name ?? "");
    setOpen(true);
  };

  return (
    <PlayNoticeContext.Provider value={{ showNotice }}>
      {children}
      {open && (
        <div
          className="fixed inset-0 z-[100] flex items-center justify-center bg-foreground-950/60 px-4"
          onClick={() => setOpen(false)}
        >
          <div
            className="w-full max-w-sm rounded-lg bg-background-50 p-6 text-center"
            onClick={(event) => event.stopPropagation()}
          >
            <div className="mx-auto w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
              <i className="ri-movie-2-line text-3xl"></i>
            </div>
            <h3 className="mt-4 text-lg font-heading font-semibold text-foreground-950">
              播放功能暂未接入
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              {title ? `《${title}》` : "该视频"}
              目前仅提供封面与资料展示，正式播放功能正在开发中，敬请期待。
            </p>
            <button
              type="button"
              onClick={() => setOpen(false)}
              className="mt-5 w-full rounded-md bg-primary-500 px-4 py-2.5 text-sm font-label font-medium text-background-50 whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              我知道了
            </button>
          </div>
        </div>
      )}
    </PlayNoticeContext.Provider>
  );
}